export const CognitoConstants = {
  cognitoIdAttribute: 'sub',
  loanStateAttribute: 'custom:loan_state',
  customerIdAttribute: 'custom:customer_id',
  lmsCustomerIdsAttribute: 'custom:lms_customer_ids',
  showPaidOffAttribute: 'custom:show_paid_off',
  phoneNumberAttribute: 'phone_number',
  phoneNumberVerifiedAttribute: 'phone_number_verified',
  emailAttribute: 'email',
  emailVerifiedAttribute: 'email_verified',
  mdmIdAttribute: 'custom:mdm_id',
  ncrAttribute: 'custom:non_customer_refer',

  lmsReferenceTlxe: 'TLXe',
  lmsReferenceNls: 'NLS'
}

export const RegexConstants = {
  stateNameFormatting: /\w*/g,
  phoneNumberFormatting: /[-() ]?/g,
  currencyFormatting: /(\d)(?=(\d{3})+\.)/g,
  storeHoursFormatting: /[am|pm]?/ig,
  lowercaseLettersTest: /[a-z]+/,
  uppercaseLettersTest: /[A-Z]+/,
  numbersTest: /[0-9]+/,
  specialCharactersTest: /[`~!@#$%^&*()+=[{\]}|\\'<,.>?/";:\-_]/, // /`|~|!|@|#|\$|%|\^|&|\*|(|)|\+|=|[|{|]|}|\||\\|'|<|,|\.|>|\?|\/|"|;|:|-|_|s/,
  loanNumberTest: /^\d{5}-?\d{1,}-?\d{1,}$/,
  phoneNumberTest: /^[(]?[2-9]{1}\d{2}[) -]{0,2}\d{3}[ -]?\d{4}$/,
  emailTest: /^\w+([.-/+]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/,
  dateTest: /^(?:(?:(?:0?[13578]|1[02])(\/|-|\.)31)\1|(?:(?:0?[1,3-9]|1[0-2])(\/|-|\.)(?:29|30)\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:0?2(\/|-|\.)29\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:(?:0?[1-9])|(?:1[0-2]))(\/|-|\.)(?:0?[1-9]|1\d|2[0-8])\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/,
  titleCaseTest: /(\w)(\w*)/g,
  partialPhone: /^[0-9]{3}/,
  ccExpirationFormatTest: /^[0-9]{2}\/[0-9]{2}$/,
  zipCodeTest: /^\d{5}$/,
  mobileDeviceTest1: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge|maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
  mobileDeviceTest2: /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i,
  nameTest: /^[a-z '-]+$/i,
  ssnTest: /^(?!(000|666|9))\d{3}-(?!00)\d{2}-(?!0000)\d{4}$/
}

export const SettingsConstants = { // Using let so values are "live"
  sessionTimeoutMinutes: 5,
  defaultLanguage: 'en',
  defaultApiTimeout: 35000, // 35 seconds
  pastDuePhoneDayLimit: 60, // 60 days
  paymentTimeoutLimit: 30,
  refiPaymentTimeoutLimit: 30,
  nlsRefiPaymentTimeoutLimit: 60, // 60 seconds
  signingStatusTimeoutLimit: 15, // Seconds
  shortCacheTimeout: 300000, // 5 minutes
  cacheTimeout: 1800000, // 30 minutes
  mediumCacheTimeout: 3600000, // 1 hour
  longCacheTimeout: 21600000, // 6 hours
  maxMoneyGramDisbursement: 10000,
  allowNlsMlaCheck: false,
  allowNoSsnRefi: false,
  showPassword: function () {
    return window.isMobileDevice
  },
  stickyHeaderId: '.sticky-wrapper',
  instaHeaderId: '#hero',
  instaSidebarId: '#pageSidebar',
  appVersion: 'BROWSER',
  allowManageNotifications: true,
  displayTermsConditionsConsent: false,
  loanDocUploadFileTypes: 'image/*,application/pdf',
  loanDocUploadMaxSize: 4, // 4 MB

  trustedDeviceSettings: {
    enabled: true
  },

  isPresentationMode: false,
  maxDisburseCardLimit: 5,
  disbursementMaxPollingAttempts: 10,
  settlementPaymentRetryLimit: 2,
  restrictedRetryTimeInMins: 15,
  loanOriginateTimeout: 10, // 10 seconds
  postDrawTimeout: 45 // 45 seconds
}

export const KeyConstants = {
  paymentsBeforeAppReview: 3, // The number of payments the user must make (after their first payment) before the app asks for an app review
  appReviewPaymentCounter: 0, // The number of payments made since the last time the app asked for an app review, if the user submits an app review or chooses do not ask again, this will be set to -1 and will prevent further app review prompts
  signingStatusSignComplete: 'signing_complete', // Pulled from DocuSign callback URL to tell when document signing is done
  signingStatusViewComplete: 'viewing_complete', // Pulled from DocuSign callback URL, returned after documents have been signed and user views again
  signingStatusSignDecline: 'decline',
  signingStatusSignExpired: 'ttl_expired',
  savedCalendarEvents: 'savedCalendarEvents', // Contains a serialized collection of calendar event objects
  deviceKey: 'deviceKey',
  viewedOfferIds: 'viewedOfferIds',
  creditLimitChange: 'creditLimitChange',
  gpsPermissionRequested: 'gpsPermissionRequested',

  waitLoadExclude: 'wait_exclude_',

  lmsIds: {
    NLS: 'NLS',
    TLXe: 'TLXe',
    Invictus: 'Invictus'
  },

  appId: {
    inl: 'com.inl.customerapp',
    tmx: 'com.titlemax.customerapp'
  }
}

/**
 * These URLs do no change based on environment.
 */
export const UrlConstants = Object.freeze({
  autoDialerUrl: 'https://www.titlemax.com/disclosures/autodialer-information?sf_traffic=mobile_app',
  googleReviewRedirectUrl: 'https://www.google.com/maps/api/js/ApplicationService.CrossOriginAuthSuccess',
  accountSiteUrl: {
    c1l: 'account.cash1loans.com',
    ccc: 'account.californiacheckcash.com',
    ccf: 'account.ccfi.com',
    chs: 'account.checksmart.com',
    cic: 'account.checkintocash.com',
    esm: 'account.easymoney.com',
    inl: 'account.instaloan.com',
    tmx: 'account.titlemax.com'
  }
})

export const AnalyticsConstants = {
  eventName: {
    addPaymentInfo: 'add_payment_info',
    appError: 'app_error',
    beginPayment: 'begin_checkout',
    finishPayment: 'ecommerce_purchase', // CT specific event
    completeCheckout: 'complete_checkout',
    linkAccount: 'link_account',
    login: 'login',
    logout: 'logout',
    register: 'sign_up', // CT specific event
    passwordChange: 'password_change',
    productSwitchCompleted: 'product_switch_finished',
    selectContent: 'select_content',
    viewItem: 'view_item',
    presentOffer: 'present_offer',
    submitContent: 'submit_content',
    portalTransaction: 'portal_transaction', // Iterable specific event
    portalAppointment: 'portal_appointment', // Iterable specific event
    accountCreated: 'account_created', // Iterable specific event
    pwaInstalled: 'pwa_installed', // Iterable specific event
    createAppointment: 'create_appointment', // CT specific event
    joinGroup: 'join_group',
    cashOut: 'cash_out',
    portalLaunched: 'portal_launched',
    error: 'error',
    share: 'share',
    screenView: 'screen_view'
  },
  propName: {
    customerId: 'customer_id',
    mobileTLXeCustomerId: 'MobileTLXeCustomerId',
    mobileNLSCustomerId: 'MobileNLSCustomerId',
    isMobileGenerated: 'IsMobileGenerated',
    usernameTypeUser: 'username_type',
    amountDue: 'amount_due',
    isPwa: 'progressive_web_app_installed',
    allowAdFeatures: 'allowAdFeatures',

    /**
     * The environment that user is currently associated with. This allows environment to be added to all events including events auto captured by Firebase.
     */
    environment: 'environment',

    /**
     * The branding of the site that events are being recorded from.
     */
    siteBrand: 'site_brand'
  },
  other: {
    disbursementPayType: 'disbursement',
    cancelRestrictStateRefiPayType: 'canceledRestrictedStateRefinance',
    cancelRefiPayType: 'canceledRefinance',
    refiPayType: 'refinance',
    resolutionPayoff: 'resolution payoff',
    standardPayType: 'standard',
    payoffPayType: 'payoff',
    disbursement: 'disbursement',
    cancelCheckoutType: 'cancel',
    completeCheckoutType: 'success',
    personalLoan: 'Personal',
    titleLoan: 'Title'
  },
  method: {
    loginType: {
      email: 'email',
      phone: 'phoneNumber'
    },
    passChange: {
      forgotPassword: 'forgotPassword'
    },
    logout: {
      reviewPayment: 'reviewPayment',
      sideBarButton: 'sideBarButton',
      sessionTimeout: 'sessionTimeout',
      trustedDeviceFailure: 'trustedDeviceFailure',
      networkError: 'networkError',
      profileLock: 'profileLock'
    }
  },
  medium: {
    login: {
      password: 'password'
    }
  },
  itemType: {
    phone: 'phone',
    email: 'email',
    termsConditionsConsent: 'termsConditionsConsent',
    pdf: 'pdf',
    ancillaryProduct: 'ancillaryProduct',
    expressLane: 'expressLane',
    disbursement: 'disbursement',
    externalApp: 'externalApp',
    progressive_web_app: 'PWA',
    standardPay: 'standard',
    guestPay: 'guest'
  }
}

export const FontConstants = {
  family: {
    source: 'Source Sans Pro, sans-serif',
    arial: 'Arial, sans-serif'
  },
  color: {
    green: '#008738',
    grey: '#4a4a4a',
    mediumgrey: '#666666',
    lightgrey: '#9b9b9b',
    red: '#cb2026',
    blue: '#00529b',
    white: '#fff'
  },
  weight: {
    light: '300',
    regular: '400',
    semibold: '600',
    bold: '800'
  }
}

export const ExternalAppConstants = Object.freeze({ // Make sure to register non-http schemes in the config.xml for iOS 9.0 and above
  scheme: {
    googleMaps () { return window.hasOwnProperty('cordova') ? window.device.platform.toLowerCase() === 'ios' ? 'comgooglemaps://' : 'com.google.android.gms.maps' : '' },
    appleMaps () { return window.hasOwnProperty('cordova') && window.device.platform.toLowerCase() === 'ios' ? 'maps://' : '' } // Apple maps is not available on Android, so return empty string
  },
  url: {
    googleMapsApp () { return ExternalAppConstants.scheme.googleMaps() + '?daddr=' },
    appleMapsApp () { return ExternalAppConstants.scheme.appleMaps() + '?daddr=' }
  }
})

export const PreferenceKeys = {
  termsConditionsConsent: 'termsConditionsConsent'
}

export const AppStatusDescType = {
  complete: 'COMPLETE'
}

export const PaymentProcessorTypeEnum = Object.freeze({ 'CyberSource': 1, 'BridgePay': 4, 'Repay': 2, 'Mixed': 3, 'None': 5 })

export const LoanDetailDisplayTypesEnum = Object.freeze({ 'singleLoan': 1, 'twoLoansSingleStore': 2, 'multiLoansSingleStore': 3, 'multiStore': 4 })

export const PermissionsEnum = Object.freeze({ 'Calendar': 'calendar', 'Camera': 'camera', 'Location': 'location', 'Notifications': 'notifications', 'File': 'file' })

export const MenuButtonEnum = Object.freeze({ 'none': 1, 'menu': 2, 'back': 3, 'cancel': 4 })

export const CancelReasonEnum = Object.freeze({ 'cancelRenewal': 1, 'statusChange': 2, 'restrictStateCancelRenewal': 3, 'optionalInsurance': 4 })

export const TooltipEnum = Object.freeze({ 'eligibleIncome': 1, 'militaryCovered': 2, 'paymentPlus': 3, 'fundsAvailable': 4, 'achEnrollment': 5, 'lastPayDate': 6, 'payDateFrequency': 7, 'discretionaryIncomeAmount': 8 })

export const LoanLockTypeEnum = Object.freeze({ 'RefiAltPartyLocked': 1 })

export const NotificationTypeEnum = Object.freeze({ 'offer': 1, 'alert': 2, 'success': 3, 'failure': 4 })

export const PaymentTypeEnum = Object.freeze({ none: 1, payment: 2, refinance: 3, settlement: 5 })

export const DisbursementTypeEnum = Object.freeze({
  none: 0,
  store: 2,
  moneyGram: 14,
  debit: 16,
  ach: 101 // ACH NLS type ID is over 100 to avoid potential future conflicts with Vergent types
})

export const DisbursementFlowTypeEnum = Object.freeze({ 'payment': 1, 'draw': 2 })

export const DefaultPhoneNumbers = Object.freeze({ 'InstaLoan': '1-855-849-5626', 'NLS': '1-888-869-4522', 'TLXe': '1-888-485-3629' })

export const AllowAccessType = Object.freeze({ 'Camera': 0, 'Photo': 1, 'File': 2 })

export const TransactionMessageType = Object.freeze({ 'Email': 0, 'Text': 1, 'Both': 2 })

export const AccountHistoryPaymentTypeEnum = Object.freeze({ 'CashAdvancePendingNotBatched': 1000, 'CashAdvancePendingBatched': 1002 })

export const RenewEnum = Object.freeze({ 'Renew': 'renew', 'Renewal': 'renewal', 'Renewing': 'renewing' })

export const DashboardItemType = Object.freeze({ 'Loan': 0, 'NlsApplication': 1, 'TLXeApplication': 2 })

export const RestrictedModalReason = Object.freeze({ 'Location': 0, 'MLA': 1 })

export const BrandEnum = Object.freeze({
  None: 1,
  TitleMax: 2,
  TitleBucks: 3,
  InstaLoan: 4,
  CheckIntoCash: 5,
  EasyMoney: 6,
  CheckSmart: 7,
  CaliforniaCheckCash: 8,
  Cash1Loans: 9,
  CommunityChoice: 10
})

export const AppBrandThemeColor = Object.freeze({
  c1l: '#04733b',
  ccc: '#003d85',
  ccf: '#1b315d',
  chs: '#02783c',
  cic: '#24836b',
  esm: '#3c6f33',
  inl: '#339328',
  rpc: '',
  spc: '',
  tbs: '',
  tmx: '#00529b'
})

export const AppBrandBackgroundColor = Object.freeze({
  c1l: '#142d47',
  ccc: '#f9f7f7',
  ccf: '#1b315d',
  chs: '#02783c',
  cic: '#323f58',
  esm: '#f7f1ec',
  inl: '#55b04c',
  rpc: '',
  spc: '',
  tbs: '',
  tmx: '#94d3eb'
})

export const AppBrandDisplayNameEnum = Object.freeze({
  c1l: 'CASH 1',
  ccc: 'California Check Cashing Stores',
  ccf: 'Community Choice Financial',
  chs: 'CheckSmart',
  cic: 'Check Into Cash',
  esm: 'easymoney',
  inl: 'InstaLoan',
  tbs: 'TitleBucks',
  tmx: 'TitleMax'
})

export const AppBrandDisplayRNameEnum = Object.freeze({
  c1l: `${AppBrandDisplayNameEnum.c1l}®`,
  ccc: `${AppBrandDisplayNameEnum.ccc}®`,
  ccf: `${AppBrandDisplayNameEnum.ccf}®`,
  chs: `${AppBrandDisplayNameEnum.chs}®`,
  cic: `${AppBrandDisplayNameEnum.cic}®`,
  esm: `${AppBrandDisplayNameEnum.esm}™`,
  inl: `${AppBrandDisplayNameEnum.inl}®`,
  tbs: `${AppBrandDisplayNameEnum.tbs}®`,
  tmx: `${AppBrandDisplayNameEnum.tmx}®`
})

export const BrandNameEnum = Object.freeze({
  [BrandEnum.None]: '',
  [BrandEnum.Cash1Loans]: AppBrandDisplayRNameEnum.c1l,
  [BrandEnum.CaliforniaCheckCash]: AppBrandDisplayRNameEnum.ccc,
  [BrandEnum.CommunityChoice]: AppBrandDisplayRNameEnum.ccf,
  [BrandEnum.CheckSmart]: AppBrandDisplayRNameEnum.chs,
  [BrandEnum.CheckIntoCash]: AppBrandDisplayRNameEnum.cic,
  [BrandEnum.EasyMoney]: AppBrandDisplayRNameEnum.esm,
  [BrandEnum.InstaLoan]: AppBrandDisplayRNameEnum.inl,
  [BrandEnum.TitleMax]: AppBrandDisplayRNameEnum.tmx,
  [BrandEnum.TitleBucks]: AppBrandDisplayRNameEnum.tbs
})

export const ServiceBrands = Object.freeze({
  None: 'none',
  Cash1Loans: 'cash 1 loans',
  CaliforniaCheckCash: 'california check cash',
  CommunityChoice: 'community choice financial',
  CheckSmart: 'check$mart',
  CheckIntoCash: 'check into cash',
  EasyMoney: 'easymoney',
  InstaLoan: 'instaloan',
  TitleMax: 'titlemax',
  TitleBucks: 'titlebucks'
})

export const AppBrands = Object.freeze({
  c1l: 'c1l',
  ccc: 'ccc',
  ccf: 'ccf',
  chs: 'chs',
  cic: 'cic',
  esm: 'esm',
  inl: 'inl',
  rpc: 'rpc',
  spc: 'spc',
  tbs: 'tbs',
  tmx: 'tmx'
})

export const NavigationBrands = Object.freeze({
  Cash1Loans: 'Cash1Loans',
  CaliforniaCheckCash: 'CaliforniaCheckCash',
  CommunityChoice: 'CommunityChoice',
  CheckSmart: 'CheckSmart',
  CheckIntoCash: 'CheckIntoCash',
  EasyMoney: 'EasyMoney',
  InstaLoan: 'InstaLoan',
  RapidCash: 'RapidCash',
  SpeedyCash: 'SpeedyCash',
  TitleMax: 'TitleMax'
})

export const AppNavigationBrands = Object.freeze({
  c1l: NavigationBrands.Cash1Loans,
  ccc: NavigationBrands.CaliforniaCheckCash,
  ccf: NavigationBrands.CommunityChoice,
  chs: NavigationBrands.CheckSmart,
  cic: NavigationBrands.CheckIntoCash,
  esm: NavigationBrands.EasyMoney,
  inl: NavigationBrands.InstaLoan,
  rpc: NavigationBrands.RapidCash,
  spc: NavigationBrands.SpeedyCash,
  tbs: NavigationBrands.TitleMax,
  tmx: NavigationBrands.TitleMax
})

export const ServiceBrandEnum = Object.freeze({
  [ServiceBrands.None]: BrandEnum.None,
  [ServiceBrands.Cash1Loans]: BrandEnum.Cash1Loans,
  [ServiceBrands.CaliforniaCheckCash]: BrandEnum.CaliforniaCheckCash,
  [ServiceBrands.CommunityChoice]: BrandEnum.CommunityChoice,
  [ServiceBrands.CheckSmart]: BrandEnum.CheckSmart,
  [ServiceBrands.CheckIntoCash]: BrandEnum.CheckIntoCash,
  [ServiceBrands.EasyMoney]: BrandEnum.EasyMoney,
  [ServiceBrands.InstaLoan]: BrandEnum.InstaLoan,
  [ServiceBrands.TitleMax]: BrandEnum.TitleMax,
  [ServiceBrands.TitleBucks]: BrandEnum.TitleBucks
})

export const LoanHistoryActionTypeEnum = Object.freeze({
  Cancel: 'cancelDraw'
})

export const InvictusSourceType = Object.freeze({
  Duplicate: 'duplicate',
  Email: 'email',
  Invictus: 'invictus',
  None: 'none',
  ShortForm: 'shortform'
})

export const AppointmentTypeEnum = Object.freeze({
  general: 1,
  productSwitch: 2,
  productSwitchAutoCreate: 3
})

export const OfferIdEnum = Object.freeze({
  settlement: 10,
  appraisal: 12,
  widget: 22
})

export const CookieConstants = Object.freeze({
  token: {
    key: 'customerportal_token',
    ttlMinutes: 5
  },
  forceRefresh: {
    key: 'ForceRefresh',
    ttlMinutes: 5
  },
  networkError: 'NetworkError',
  gpsInstructionsReceipt: {
    key: 'GpsInstructionsReceipt',
    ttlSeconds: 604800
  },
  origination: {
    key: 'Origination',
    ttlMinutes: 7200 // 7200 is 5 days worth of minutes
  },
  locationValidated: {
    key: 'LocationValidated',
    ttlMinutes: 10
  },
  invictusAccessToken: {
    key: 'pwa_auth_token',
    ttlMinutes: 2880
  }
})

export const ErrorTypes = Object.freeze({
  profileLocked: 'ProfileLocked'
})

export const DefaultPasswordPolicy = Object.freeze({
  minimumLength: 9,
  requireUppercase: true,
  requireLowercase: true,
  requireNumbers: true,
  requireSymbols: false,
  requireNoSpaces: true
})

export const ExternalBrowserType = Object.freeze({
  InApp: 'IAB',
  Tabs: 'Tabs'
})

export const Cards = Object.freeze({
  transactionType: {
    /**
     * Cards are used for making payments on loans.
     */
    payment: {
      id: 1,
      name: 'payment'
    },

    /**
     * Cards are used for push to debit disbursement method.
     */
    disbursement: {
      id: 2,
      name: 'disbursement'
    },

    /**
     * Cards are used for push to debit disbursement method.
     */
    refer: {
      id: 3,
      name: 'refer'
    }
  }
})

export const OsType = Object.freeze({
  Android: 'Android',
  Apple: 'Apple',
  Unknown: 'Unknown'
})

export const DesktopOsType = Object.freeze({
  Windows: 'Windows',
  Mac: 'Mac',
  Unknown: 'Unknown'
})

export const BrowserType = Object.freeze({
  Chrome: 'Chrome',
  Safari: 'Safari',
  Samsung: 'Samsung',
  Unknown: 'Unknown'
})

export const EcommBankingStatus = Object.freeze({
  Success: 'SUCCESS',
  Fail: 'FAIL',
  Unsupported: 'UNSUPPORTED',
  Skip: 'SKIP',
  Abandon: 'ABANDON',
  Refresh: 'REFRESH'
})

export const SigningType = Object.freeze({
  refinance: 'Refinance',
  settlement: 'Settlement'
})

export const DisclosureType = Object.freeze({
  refinance: 'refinance',
  appraisal: 'appraisal'
})

export const TransactionType = Object.freeze({
  addOn: 'AddOn',
  payment: 'Payment',
  refi: 'Refi'
})

export const NcrType = Object.freeze({
  customer: 'customer'
})

export const ReferralType = Object.freeze({
  none: 'none',
  ncr: 'ncr',
  ecr: 'ecr'
})

export const ReferralSource = Object.freeze({
  email: 'email',
  text: 'text',
  share: 'share',
  qr: 'qr'
})

export const CardTypeEnum = Object.freeze({
  amex: 'amex',
  discover: 'discover',
  masterCard: 'mastercard',
  visa: 'visa',
  bank: 'bank'
})

export const AutoPayType = Object.freeze({
  card: 'card',
  bank: 'bank'
})

export const TlxeLoanStatusEnum = Object.freeze({
  PaidOff: 3,
  ChargedOff: 6,
  Closed: 8,
  Deleted: 10,
  Open: 12,
  Repossessed: 13,
  OutForRepo: 15,
  Sold: 16,
  Bankrupt: 17,
  Refinance: 22,
  OutForRepoChargedOff: 23,
  RepossessedChargedOff: 24,
  Default: 27,
  Rescinded: 28,
  Settled: 29,
  ActiveDefault: 31,
  BankruptChargedOff: 32,
  Chargeback: 33
})

export const ModalIdentifier = Object.freeze({
  locationDisclaimer: 'locationDisclaimerModal',
  productSwitchOffer: 'productSwitchModal'
})
